<!-- 按钮 -->
<template>
  <div class="button-comp">
    <el-button type="danger" disabled class="button-name">{{ option.content }}</el-button>
  </div>
</template>

<script>
export default {
  name: 'ButtonComp',
  props: ['option']
}
</script>

<style lang="scss" scoped>
.button-comp {
  margin-bottom: 10px;
  display: inline-block;
  .button-name {
    margin-left: 10px;
  }
}
</style>
